module.exports = __webpack_public_path__ + "img/noun-coins.1a3a38af.svg";